import { type ApprovalPolicyAssignment } from 'types/api.types';

export const POLICY_CATALOG_REPO = 'https://github.com/env0/policy-catalog';

export const hasCustomApprovalPolicyAssignment = (assignments: ApprovalPolicyAssignment[]) => {
  return assignments.some(assignment => assignment.blueprint?.repository !== POLICY_CATALOG_REPO);
};
